import React, { FC, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Card from '../atoms/Card'
import styles from './CardsContent.module.scss'
import SwipeLabelContainer from './SwipeLabelContainer'
import SwipeButtonsContainer from './SwipeButtonsContainer'
import { CardEntity } from '../../ducks/cards/types'
import ServicesModalContainer from '../molecules/ServicesModalContainer'

interface CardsProps {
  cards: CardEntity[]
  modals: CardEntity[]
  swipeCard(): void
  addModal(card: CardEntity): void
  resetModal(): void
}

const CardsContent: FC<CardsProps> = ({cards, swipeCard, addModal, modals, resetModal}) => {

  const [ isDisplayLeftLabel, setIsDisplayLeftLabel ] = useState(false)
  const [ isDisplayRightLabel, setIsDisplayRightLabel ] = useState(false)

  const setDisplayLabel = (direct: string) => {
    switch(direct) {
      case 'LEFT':
        setIsDisplayLeftLabel(true)
        setIsDisplayRightLabel(false)
        break
      case 'RIGHT':
        setIsDisplayRightLabel(true)
        setIsDisplayLeftLabel(false)
        break
    }
  }

  useEffect(() => {
    setIsDisplayRightLabel(false)
    setIsDisplayLeftLabel(false)
  }, [cards])

  return (
    <div className={ styles.cardsContent }>
      <div className={ styles.cards }>
        {
          cards
            .slice(0, 20)
            .map(card => (
              <Card
                card={ card }
                key={ card.id }
                setDisplayLabel={ (direct) => setDisplayLabel(direct) }
                swipeCard={ swipeCard }
                addModal={addModal} />
            ))
        }
        <Link to="/search">
          <div className={ styles.searchButton }>
            女優を探す
          </div>
        </Link>
      </div>
      <SwipeLabelContainer
        isDisplayLeftLabel={isDisplayLeftLabel}
        isDisplayRightLabel={isDisplayRightLabel}
      />
      <SwipeButtonsContainer
        cards={cards}
        swipeCard={swipeCard}
        addModal={addModal}
      />
      { modals[0] && <ServicesModalContainer card={modals[0]} resetModal={resetModal}/> }
    </div>
  )
}

export default CardsContent